import * as NavConstants from 'constants/NavConstants';
import {getSelectedPageSize} from 'nav/sidepanel/PageSizeUtil';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import {openListing} from 'nav/sidepanel/SidepanelReduxActions';
import {getStore} from 'redux-stores/Store';
import {getFilterByKey} from 'search/FilterUtil';
import {
  convertFromGraphqlSavedSearchParams,
  NonPaginatedSearchParams,
  SavedSearch,
} from 'search/saved-searches/SavedSearchUtil';
import {FilterKey, SingleValueFilter} from 'search/SearchConstants';

export function switchToSavedSearchRegistryForStorageSidepanel(savedSearch?: SavedSearch): Promise<void> {
  // If we are trying to unload a saved search, we don't need to do anything special, so simply return.
  if (!savedSearch) {
    return Promise.resolve();
  }

  const searchParams = convertFromGraphqlSavedSearchParams(savedSearch.searchParams);
  switchToSavedSearchRegistryForStorageSidepanelWithParams(searchParams);

  return Promise.resolve();
}

export function switchToSavedSearchRegistryForStorageSidepanelWithParams(
  searchParams: NonPaginatedSearchParams
): Promise<void> {
  const registryFilter = getFilterByKey(searchParams.filters, FilterKey.REGISTRY) as SingleValueFilter;
  if (!registryFilter) {
    throw new Error('No registry filter specified for inventory listing saved search.');
  }

  SidepanelActions.setStorablesSidepanelActiveRegistry(registryFilter.value);
  getStore().dispatch(
    openListing(NavConstants.SECTIONS.STORAGE, {
      offset: 0,
      limit: getSelectedPageSize(),
      ...searchParams,
    })
  );

  return Promise.resolve();
}
